<script lang="ts">
    import type {SummarySectionType, SummaryPaymentState} from '../../types';
    import {summaryTypeLabel} from '../../utils';
    import AttendanceCell from '../AttendanceCell.svelte';

    export let type: SummarySectionType;
    export let paymentState: SummaryPaymentState | null = null;
</script>

<div class="attendance-summary-section-wrapper {type}">
    <div class="attendance-summary-section {type}">
        <AttendanceCell header>{summaryTypeLabel(type)}</AttendanceCell>

        <div class="columns-container">
            <slot/>
        </div>
    </div>

    {#if paymentState}
        <span class="payment-state">
            {paymentState.value}
        </span>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    @work-type-highlight: #EAEEFF;
    @overtime-type-highlight: #FFF4ED;
    @absence-type-highlight: #F3F1FF;
    @oncallduty-type-highlight: #F8F8F8;
    @idp-type-highlight: #edfaf2;

    .attendance-summary-section-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1;

        &.section-legend {
            flex: 0;
        }

        &.absence {
            flex: 2;
        }

        &.on-call-duty {
            flex: 0;
        }

        &.idp {
            flex: 0;
        }

        .payment-state {
            width: 100%;
            text-align: center;
            font-weight: bold;
            margin-top: auto;
            padding-top: @spacing-xs;
            font-size: @font-size-large;
        }
    }

    .attendance-summary-section {
        display: flex;
        flex-direction: column;
        border-radius: @border-radius-large;
        border: 1px solid @themed-border-default;

        .columns-container {
            display: flex;
        }

        &.section-legend {
            border: none;
            background: none;
        }

        &.work {
            background-color: @work-type-highlight;
        }

        &.overtime {
            background-color: @overtime-type-highlight;
        }

        &.absence {
            background-color: @absence-type-highlight;
        }

        &.on-call-duty {
            background-color: @oncallduty-type-highlight;
        }

        &.idp {
            background-color: @idp-type-highlight;
        }
    }

    :global {
        .attendance-summary-section {
            &.section-legend .attendance-calendar-cell {
                border-bottom: none;
                background: none;
                padding: 0;
                justify-content: start;

                &.header-cell {
                    border-bottom: none;
                }

                &:hover {
                    background: none;
                }
            }
        }
    }
</style>